import { TextButton } from '@oneaudi/unified-web-alpha-components';
import { useI18n } from '~/app/i18n/i18n';
import { StatusFragment } from '~/graphql/__generated__/graphql';

export function DialogItemActionButton({
	status,
	onAddToConfiguration,
	isFullWidth,
}: {
	status: StatusFragment;
	onAddToConfiguration: () => void;
	isFullWidth?: boolean;
}) {
	const { i18n } = useI18n();

	if (!status.selected && status.available) {
		// Item can be added to configuration
		return (
			<TextButton isFullWidth={isFullWidth} variant="primary" onClick={onAddToConfiguration} size="sm">
				{i18n('ngc.actions.addToConfiguration')}
			</TextButton>
		);
	}

	if (status.selected) {
		// Item is already selected
		return (
			<TextButton isFullWidth={isFullWidth} variant="secondary" disabled size="sm" onClick={() => {}}>
				{i18n('ngc.actions.includedInConfiguration')}
			</TextButton>
		);
	}

	// Item is not available
	return (
		<TextButton isFullWidth={isFullWidth} variant="secondary" disabled size="sm" onClick={() => {}}>
			{i18n('ngc.common.NotAvailable')}
		</TextButton>
	);
}
